<template>
  <div class="rounded rounded-t-lg bg-white shadow p-4">
    <div class="flex">
      <div class="w-1/3 mr-1">
        <label class="block text-sm leading-5 font-medium text-gray-700">First Name</label>
        <input aria-label="First Name" name="firstName" type="text" required
               v-model="user.first_name" class="appearance-none rounded-md
                                   relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md
                                    focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5"
               placeholder="First Name"/>
      </div>
      <div class="w-1/3 mx-1">
        <label class="block text-sm leading-5 font-medium text-gray-700">Middle Name</label>
        <input aria-label="Last Name" name="lastName" type="text" required
               v-model="user.middle_name" class="appearance-none rounded-md
                                   relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md
                                    focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5"
               placeholder="Middle Name"/>
      </div>
      <div class="w-1/3 ml-1">
        <label class="block text-sm leading-5 font-medium text-gray-700">Last Name</label>
        <input aria-label="Last Name" name="lastName" type="text" required
               v-model="user.last_name" class="appearance-none rounded-md
                                   relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md
                                    focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5"
               placeholder="Last Name"/>
      </div>
    </div>
    <div class="my-3">
      <label class="block text-sm ">Email Address</label>
      <input aria-label="Email address" name="email" type="email" required
             v-model="user.email_address" class="appearance-none rounded-md
                                   relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900
                                    focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5"
             placeholder="Email address"/>
    </div>
    <div class="my-3">
      <label class="block text-sm ">Phone Number</label>
      <input aria-label="Phone Number" type="text" required
             v-model="user.phone_number" class="appearance-none rounded-md
                                   relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900
                                    focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5"
             placeholder="Phone Number"/>
    </div>
    <div class="mt-6">
      <button v-if="$store.getters.can('edit_clients')" v-on:click="updateClient"
              class="float-right rounded-sm px-4 md:px-5 xl:px-4 py-2  bg-teal-500 hover:bg-teal-600 md:text-lg leading-tight
                       xl:text-base text-white">
        UPDATE
      </button>
      <div class="clear-both"></div>
    </div>
  </div>
</template>

<script>
import GraphQl from "@/services/graphql.service";

export default {
  name: "CustomerDetails",
  components: {},
  data() {
    return {
      user: Object
    }
  },
  props: {
    customerId: String,
    path: String,
  },
  mounted() {
    this.getCustomerProfile();
  },
  methods: {
    getCustomerProfile() {
      this.loading = true
      GraphQl.sendRequest('{organization(id:"' + this.$store.getters.orgId + '"){customer(customerId:"' + this.customerId + '") ' +
          '{devicesCount connectionsCount identity name first_name last_name middle_name phone_number email_address}}}')
          .then(response => {
            this.user = response.organization.customer;
          })
    },
    updateClient() {

    }
  }
}
</script>

<style scoped>

</style>